import { render, staticRenderFns } from "./ModalRequestToDepartment.vue?vue&type=template&id=bb02b822&lang=pug&"
import script from "./ModalRequestToDepartment.vue?vue&type=script&lang=js&"
export * from "./ModalRequestToDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ModalRequestToDepartment.vue?vue&type=style&index=0&id=bb02b822&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports